export const sum = xs => xs.reduce((a, b) => a + b, 0);
export const mean = xs => sum(xs) / xs.length;
export const clamp = (x, min, max) => Math.max(Math.min(x, max), min);
export const lerp = (a, b, t) => a + (b - a) * t;
export const inverseLerp = (a, b, x) => (x - a) / (b - a);
export const map = (x, oldMin, oldMax, newMin, newMax) => lerp(newMin, newMax, inverseLerp(oldMin, oldMax, x));